var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"asideOptions_item toggle"},_vm._l((_vm.buttons),function(item,idx){return _c('a',{class:{
      asideOptions_link: true,
      selected: item.value===_vm.selected,
    },on:{"click":function($event){return _vm.onClick(item, idx)}}},[_vm._v(_vm._s(item.title))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }